import styled from 'styled-components'

export const AccordionLabel = styled.div`
  padding-right: 30px;
  line-height: 1.5;
  font-size: 20px;
  font-weight: var(--font-medium);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`
